var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainBody d-flex px-3 py-2 m-4 border border-dark shadow"},[_c('div',{staticClass:"profileImageBody rounded-circle mx-3"},[_c('img',{staticClass:"h-100 w-100 rounded-circle",attrs:{"src":_vm.imgsrc},on:{"error":_vm.fallbackImg}})]),_c('p',{staticClass:"my-auto h5 font-weight-bold"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }